/**
 * Resend-cooldown maths, kept pure so it can be tested in node (the web app has
 * no DOM test harness). The React wiring — a 1s ticker and a disabled button —
 * is thin and lives in `ResendButton`; everything worth asserting is here.
 *
 * The number mirrors the server's `OTP_RESEND_COOLDOWN_SECONDS`; the server is
 * the authority (it returns `retryAfterSeconds`), and this is the fallback the
 * client seeds a countdown with before it has heard back.
 */
export const OTP_RESEND_COOLDOWN_SECONDS = 60;

/**
 * Whole seconds left until `until` (epoch ms), never negative. `null` means no
 * cooldown is running, so nothing to wait for.
 */
export function secondsLeft(until: number | null, now: number): number {
  if (until === null) return 0;
  return Math.max(0, Math.ceil((until - now) / 1000));
}
